import React from 'react';
import {
    ATMModal,
    ATMButton,
    ATMForm,
    ATMGrid,
    ATMInput,
    ATMField,
    ATMIcon,
    ORGDataTable,
    IORGDataTableColumn,
    IORGDataTableQueryState,
} from 'shared-it-appmod-ui';
import moment from 'moment-timezone';
import Lang from 'src/libraries/language';

type Iprops = {
    data: any;
    openAuditLogs: boolean;
    handleClose: () => void;
    loadinglog: boolean;
    fetchLogData: (params: IORGDataTableQueryState) => void;
    totalRecord: number;
};

function PrimeUsersAuditLogView({
    data,
    openAuditLogs,
    handleClose,
    loadinglog,
    fetchLogData,
    totalRecord,
}: Iprops) : any {

    

    const columns: IORGDataTableColumn<any>[] = [
        {
            title: 'Contract Number',
            index: 'contract_number',
            render: (_, value) => (
                <span>{`${ value?.contract_number ? value?.contract_number : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.von,
            },
        },
        {
            title: 'Subcontractor Name',
            index: 'subcontractorName',
            sortable: false,
            render: (_, value) => <span>{value?.subcontractorName || '-'}</span>,
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: 'Spend Year',
            index: 'spendYear',
            sortable: false,
            render: (_, value) =>(
                <span>{`${ value?.spendYear ? value?.spendYear : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: 'Spend Month',
            index: 'spendMonth',
            render: (_, value) => (
                <span>{`${ value?.spendMonth ? value?.spendMonth : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.von,
            },
        },
        {
            title: 'Previous Spend Amount',
            index: 'prevAmount',
            sortable: false,
            render: (_, value) => (
                <span>{value?.prevAmount || '-'}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: 'New Spend Amount',
            index: 'newAmount',
            sortable: false,
            render: (_, value) =>(
                <span>{`${ value?.newAmount ? value?.newAmount : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: 'Spend Type',
            index: 'isTier3Spend',
            sortable: false,
            render: (_, value) =>(
                <span>{`${ value.isTier3Spend ? 'Tier III' : 'Tier II'}`}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: 'Done by',
            index: 'updatedBy',
            sortable: false,
            render: (_, value) =>(
                <span>{`${ value?.updatedBy ? value?.updatedBy : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        },
        {
            title: 'Timestamp',
            index: 'updatedAt',
            sortable: false,
            render: (_, value) =>(
                <span>{`${ value?.updatedAt && value?.updatedAt !='-' ? moment.utc(value?.updatedAt).format('MM/DD/YYYY hh:mm A') : '-'}`}</span>
            ),
            headerProps: {
                //className: Style.prime,
            },
        }
    ];
    return (
        <ATMModal
            size="large"
            open={openAuditLogs}
            onClose={handleClose}
            closeOnDimmerClick={false}
        >
            <ATMModal.Header as="h5">
                Prime Spend Audit Log
                <ATMIcon name="close" onClick={handleClose} style={{ color: '#606060',position: 'absolute','right': '0',top: '5px',cursor: 'pointer' }} />
            </ATMModal.Header>

            <ATMModal.Content>
                <ORGDataTable
                   celled={false}
                   columns={columns}
                   data={data}
                   loading={loadinglog}
                   sortable
                   // toolbar
                   // history
                   counter
                   // filters={true}
                   noDataText={Lang.MSG_NO_RECORDS_TO_DISPLAY}
                   onChange={fetchLogData}
                   total={totalRecord}
                   key={totalRecord}
                   rowsPerPageOptions={[10, 20, 25]}
                />
            </ATMModal.Content>
        </ATMModal>
    );
}

export default PrimeUsersAuditLogView;
